import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import SearchInput from '../common-inputs/SearchInput';
import ProjectSelectItem from './ProjectSelectItem';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import CircleCounter from '../circle-counter/CircleCounter';
import selectElementInArray from '../../utils/selectElementInArray';

import scss from './ProjectsSelect.module.scss';

function ProjectsSelect({ projectList = [], activeProjects = [], onSelect, className }) {
  const { t } = useTranslation('customers');
  const [searchStr, setSearchStr] = useState('');

  const [localActiveProjects, setLocalActiveProjects] = useState([]);

  const filteredProjects = useMemo(
    () => projectList.filter(({ name }) => name.toLowerCase().includes(searchStr.toLowerCase())),
    [projectList, searchStr],
  );

  const handleSelect = ({ id, checked }) => {
    if (onSelect) {
      onSelect({ id, checked });
      setLocalActiveProjects((prevProjects) => selectElementInArray(prevProjects, id, checked));
    }
  };

  useEffect(() => {
    setLocalActiveProjects(activeProjects);
  }, [activeProjects]);

  return (
    <div className={clsx(scss.wrapper, className)}>
      <SearchInput value={searchStr} onChange={setSearchStr} size='sm' name='project-search' />

      <div className={scss.contentWrapper}>
        <CircleCounter count={localActiveProjects.length} className={scss.counter} />

        {filteredProjects.length ? (
          <ul className={scss.list}>
            {filteredProjects.map((project) => (
              <ProjectSelectItem
                key={project.id}
                name={project.name}
                id={project.id}
                enabled={project.enabled}
                checked={localActiveProjects.includes(project.id)}
                onSelect={handleSelect}
                searchStr={searchStr}
              />
            ))}
          </ul>
        ) : (
          <div className={scss.noProjects}>
            <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className={scss.noProjectsIcon} />
            {t('noProjects')}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectsSelect;
